module.exports = __webpack_public_path__ + "img/one-column-list-help.cac6abd3.png";